import { userGroupService, accountUserService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_USER_GROUPS,
  ADD_NEW_USER_GROUP,
  REPLACE_USER_GROUP,
  SET_EXISTING_MANAGER_USERS,
  REMOVE_EXISTING_MANAGER_USER,
} from './mutationTypes';
import {
  GET_USER_GROUPS,
  CREATE_USER_GROUPS,
  UPDATE_USER_GROUP,
  DELETE_USER_GROUP,
  UNLINK_USER_FROM_GROUP,
  GET_EXISTING_MANAGER_USERS,
  LINK_EXISTING_USER_TO_GROUP
} from './actionTypes';

import { REMOVE_UNLINKED_USER, ADD_LINKED_USER } from '@/modules/invites/store/mutationTypes';

import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR } from '@/store/helpers';

const actions = {
  async [GET_USER_GROUPS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_USER_GROUPS });
    commit(SET_USER_GROUPS, []);
    try {
      const response = await userGroupService.getGroups(rootState.currentAccountId);
      commit(SET_USER_GROUPS, response.data.managers);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_USER_GROUPS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_USER_GROUPS, error: e });
    }
  },
  async [CREATE_USER_GROUPS]({ rootState, commit }, userGroup) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: CREATE_USER_GROUPS });
    try {
      const response = await userGroupService.createGroup(rootState.currentAccountId, userGroup);
      commit(ADD_NEW_USER_GROUP, response.data.manager);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: CREATE_USER_GROUPS, newGroup: response.data.manager });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: CREATE_USER_GROUPS, error: e });
    }
  },
  async [UPDATE_USER_GROUP]({ rootState, commit }, userGroup) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UPDATE_USER_GROUP });
    try {
      const response = await userGroupService.updateGroup(rootState.currentAccountId, userGroup);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UPDATE_USER_GROUP });
      commit(REPLACE_USER_GROUP, response.data.manager);
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UPDATE_USER_GROUP, error: e });
    }
  },
  async [DELETE_USER_GROUP]({ rootState, commit, dispatch }, userGroupId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_USER_GROUP });
    try {
      await userGroupService.deleteGroup(rootState.currentAccountId, userGroupId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_USER_GROUP });
      dispatch('getUserGroups');
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_USER_GROUP, error: e });
    }
  },
  async [UNLINK_USER_FROM_GROUP]({ rootState, commit }, userToDelete) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UNLINK_USER_FROM_GROUP });
    try {
      const response = await userGroupService.unlinkUserFromGroup(rootState.currentAccountId, userToDelete.managerId, userToDelete.userId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UNLINK_USER_FROM_GROUP });
      commit(REPLACE_USER_GROUP, response.data.manager);
      commit('invites/' + REMOVE_UNLINKED_USER, {
        unlinkedUserId: userToDelete.userId,
        inviteTargetType: 'managers',
        inviteTargetId: userToDelete.managerId
      }, { root: true });

      if (userToDelete.managerCombinedIDs?.filter(i => i.startsWith(rootState.currentAccountId))?.length === 1) {
        commit(REMOVE_EXISTING_MANAGER_USER, userToDelete.userId);
      }
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UNLINK_USER_FROM_GROUP, error: e });
    }
  },
  async [GET_EXISTING_MANAGER_USERS]({ rootState, state, commit }) {
    if (!state.existingAccountUsers.length) {
      commit(SET_ACTION_STATUS_PENDING, { actionName: GET_EXISTING_MANAGER_USERS });
      try {
        const users = await accountUserService.getAccountUsers(rootState.currentAccountId);
        commit(SET_EXISTING_MANAGER_USERS, users);
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_EXISTING_MANAGER_USERS });
      } catch (e) {
        commit(SET_ACTION_STATUS_ERROR, { actionName: GET_EXISTING_MANAGER_USERS, error: e });
      }
    }
  },
  async [LINK_EXISTING_USER_TO_GROUP]({ rootState, commit }, existingUser) {
    if (existingUser?.id && existingUser?.inviteTargetId) {
      commit(SET_ACTION_STATUS_PENDING, { actionName: LINK_EXISTING_USER_TO_GROUP });
      try {
        const response = await userGroupService.linkExistingUserToGroup(rootState.currentAccountId, existingUser.inviteTargetId, existingUser.id);
        commit(REPLACE_USER_GROUP, response.data.manager);
        // TODO: Move to invite service function
        commit('invites/' + ADD_LINKED_USER, {
          invite: {
            acceptanceDate: '2021-03-25T00:00:00.0000000Z',
            associatedRoleIds: [existingUser.inviteTargetId],
            createdDate: '2021-03-25T00:00:00.0000000Z',
            email: existingUser.email,
            enabled: true,
            expirationDate: '2021-04-24T00:00:00.0000000Z',
            firstName: existingUser.firstName,
            id: 'USER' + existingUser.id,
            isActive: false,
            lastName: existingUser.lastName,
            role: existingUser.role,
            url: '',
            user: existingUser,
            name: existingUser.name,
            status: 'Accepted',
            statusClass: 'label-success'
          },
          inviteTargetType: 'managers',
          inviteTargetId: existingUser.inviteTargetId
        }, { root: true });
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: LINK_EXISTING_USER_TO_GROUP });
      } catch (e) {
        commit(SET_ACTION_STATUS_ERROR, { actionName: LINK_EXISTING_USER_TO_GROUP, error: e });
      }
    }
  }
};

export default actions;